import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import FolderBreadcrumb, {
  BreadcrumbWrapper,
  StyledBreadcrumb,
} from './FolderBreadcrumb';
import BreadcrumbsWrapper from './BreadcrumbsWrapper';
import { FormattedMessage } from 'react-intl';

type FolderBreadcrumbsProps = {
  breadcrumbs: [number, string][];
  onCloseFolder: (folderStateIndex: number) => void;
};

const FolderBreadcrumbs = ({
  breadcrumbs,
  onCloseFolder,
}: FolderBreadcrumbsProps) => {
  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <BreadcrumbsWrapper>
      <BreadcrumbWrapper>
        <StyledBreadcrumb color="secondary" onClick={() => onCloseFolder(1)}>
          <FormattedMessage id="portfolio.challenge.files.add.select.onedrive.file_picker.breadcrumbs.all_files" />
        </StyledBreadcrumb>
        <ChevronRightIcon />
      </BreadcrumbWrapper>
      {breadcrumbs.map(([folderStateIndex, folderName], i) => (
        <FolderBreadcrumb
          folderName={folderName}
          onCloseChildFolders={() => onCloseFolder(folderStateIndex + 1)}
          isActiveFolder={i === breadcrumbs.length - 1}
          key={i}
        />
      ))}
    </BreadcrumbsWrapper>
  );
};

export default FolderBreadcrumbs;
